export const TRANSLATE_MAP = {
  ar: {
    featured: '\u200Fمميزة',
    shoes: '\u200Fأحذية',
    lighting: '\u200Fإضاءة',
    accessories: '\u200Fإكسسوارات',
    womensClothing: '\u200Fملابس نسائية',
    healthSupplements: '\u200Fمكملات صحية' // 保健品
  },
  de: {
    featured: 'Ausgewählte',
    shoes: 'Schuhe',
    lighting: 'Beleuchtung',
    accessories: 'Accessoires',
    womensClothing: 'Damenbekleidung',
    healthSupplements: 'Gesundheitsprodukte'
  },
  en: {
    featured: 'Featured',
    shoes: 'Shoes',
    lighting: 'Lighting',
    accessories: 'Accessories',
    womensClothing: "Women's Clothing",
    healthSupplements: 'Health Supplements'
  },
  es: {
    featured: 'Destacados',
    shoes: 'Zapatos',
    lighting: 'Iluminación',
    accessories: 'Accesorios',
    womensClothing: 'Ropa de Mujer',
    healthSupplements: 'Productos de Salud'
  },
  fa: {
    featured: '\u200Fبرگزیده',
    shoes: '\u200Fکفش‌ها',
    lighting: '\u200Fروشنایی',
    accessories: '\u200Fلوازم جانبی',
    womensClothing: '\u200Fلباس زنانه',
    healthSupplements: '\u200Fمحصولات سلامتی'
  },
  fr: {
    featured: 'Sélection',
    shoes: 'Chaussures',
    lighting: 'Éclairage',
    accessories: 'Accessoires',
    womensClothing: 'Vêtements Femme',
    healthSupplements: 'Produits de Santé'
  },
  hi: {
    featured: 'चुनिंदा',
    shoes: 'जूते',
    lighting: 'लाइटिंग',
    accessories: 'एक्सेसरीज़',
    womensClothing: 'महिला वस्त्र',
    healthSupplements: 'स्वास्थ्य उत्पाद'
  },
  it: {
    featured: 'In Evidenza',
    shoes: 'Scarpe',
    lighting: 'Illuminazione',
    accessories: 'Accessori',
    womensClothing: 'Abbigliamento Donna',
    healthSupplements: 'Prodotti Salute'
  },
  ja: {
    featured: '特選',
    shoes: 'シューズ',
    lighting: '照明',
    accessories: 'アクセサリー',
    womensClothing: 'レディース服',
    healthSupplements: '健康製品'
  },
  ko: {
    featured: '추천',
    shoes: '신발',
    lighting: '조명',
    accessories: '액세서리',
    womensClothing: '여성 의류',
    healthSupplements: '건강 제품'
  },
  ms: {
    featured: 'Terpilih',
    shoes: 'Kasut',
    lighting: 'Pencahayaan',
    accessories: 'Aksesori',
    womensClothing: 'Pakaian Wanita',
    healthSupplements: 'Produk Kesihatan'
  },
  nl: {
    featured: 'Uitgelichte',
    shoes: 'Schoenen',
    lighting: 'Verlichting',
    accessories: 'Accessoires',
    womensClothing: 'Dameskleding',
    healthSupplements: 'Gezondheidsproducten'
  },
  pl: {
    featured: 'Wyróżnione',
    shoes: 'Buty',
    lighting: 'Oświetlenie',
    accessories: 'Akcesoria',
    womensClothing: 'Odzież damska',
    healthSupplements: 'Produkty Zdrowotne'
  },
  pt: {
    featured: 'em Destaque',
    shoes: 'Sapatos',
    lighting: 'Iluminação',
    accessories: 'Acessórios',
    womensClothing: 'Roupas Femininas',
    healthSupplements: 'Produtos de Saúde'
  },
  ru: {
    featured: 'Избранная',
    shoes: 'обувь',
    lighting: 'Освещение',
    accessories: 'аксессуары',
    womensClothing: 'Женская одежда',
    healthSupplements: 'Товары для здоровья'
  },
  sw: {
    featured: 'Vilivyochaguliwa',
    shoes: 'Viatu',
    lighting: 'Taa',
    accessories: 'Vifaa',
    womensClothing: 'Mavazi ya Wanawake',
    healthSupplements: 'Bidhaa za Afya'
  },
  th: {
    featured: 'คัดสรร',
    shoes: 'รองเท้า',
    lighting: 'แสงสว่าง',
    accessories: 'เครื่องประดับ',
    womensClothing: 'เสื้อผ้าผู้หญิง',
    healthSupplements: 'ผลิตภัณฑ์เพื่อสุขภาพ'
  },
  tr: {
    featured: 'Öne Çıkan',
    shoes: 'Ayakkabılar',
    lighting: 'Aydınlatma',
    accessories: 'Aksesuarlar',
    womensClothing: 'Kadın Giyim',
    healthSupplements: 'Sağlık Ürünleri'
  },
  vi: {
    featured: 'Nổi Bật',
    shoes: 'Giày',
    lighting: 'Chiếu sáng',
    accessories: 'Phụ kiện',
    womensClothing: 'Quần áo nữ',
    healthSupplements: 'Sản phẩm Sức khỏe'
  },
  zh: {
    featured: '精选',
    shoes: '鞋子',
    lighting: '灯具',
    accessories: '配饰',
    womensClothing: '女装',
    healthSupplements: '保健品'
  }
}

export const FEATURED_LIST = [
  {
    path: '/featured/lighting',
    name: 'lighting',
    prefix: '💡'
  },
  {
    path: '/featured/accessories',
    name: 'accessories',
    prefix: '💍'
  },
  {
    path: '/featured/womensClothing',
    name: 'womensClothing',
    prefix: '👗'
  },
  {
    path: '/featured/healthSupplements',
    name: 'healthSupplements',
    prefix: '🍀'
  }
]

/**
 * @deprecated 已废弃，直接使用 isMobile 替代
 */
export const deviceType = (() => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})()

/**
 * 判断当前设备型号是否是 H5
 * @returns {boolean}
 */
export const isMobile = (() => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent)
})()
